import { computed } from 'vue'
// types
import type { ComputedRef } from 'vue'
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import type { SocialButtonProps, SocialNetwork } from '../types/interfaces'
// assets
import { faFacebookF, faInstagram, faLinkedinIn, faRedditAlien } from '@fortawesome/free-brands-svg-icons'

const NETWORK_ICONS: Record<SocialNetwork, IconDefinition> = {
  facebook: faFacebookF,
  linkedin: faLinkedinIn,
  instagram: faInstagram,
  reddit: faRedditAlien,
}

interface SocialButtonHookOptions {
  props: SocialButtonProps
}

interface SocialButtonHookReturn {
  refIcon: ComputedRef<IconDefinition>
}

export const useSocialButton = ({ props }: SocialButtonHookOptions): SocialButtonHookReturn => {
  const refIcon = computed<IconDefinition>(() => NETWORK_ICONS[props.network])

  return {
    refIcon,
  }
}
